import React from "react";

const CourseContext = React.createContext()

export default CourseContext;